<template>
  <div class="content-left icon-top-jb" :class="{ navLeftWidth: isCollapse }">
    <div class="scroll-menu">
      <div class="user-info-side">
        <transition name="fade">
          <img
            v-if="!isCollapse"
            src="../assets/images/tianyukeji.png"
            alt=""
            style="width: 180px; margin: 0 auto"
          />
        </transition>
        <transition name="fade">
          <img
            v-if="isCollapse"
            src="../assets/images/tianyu.png"
            alt=""
            style="width: 40px; margin: 0 auto"
          />
        </transition>
      </div>
      <transition name="fade">
        <el-menu
          :default-active="activeIndex"
          :collapse="isCollapse"
          class="el-menu-vertical-demo"
          router
        >
          <el-menu-item index="/">
            <i class="el-icon-s-home"></i>
            <span slot="title">Home</span>
          </el-menu-item>
          <el-submenu index="2" v-if="filterMenu('manager')">
            <template slot="title">
              <i class="el-icon-help"></i>
              <span>管理中心</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/subject/list"
                v-if="filterMenu('manager_subject')"
                >项目列表</el-menu-item
              >
              <el-menu-item
                index="/device/list"
                v-if="filterMenu('manager_device')"
                >设备列表</el-menu-item
              >
              <el-menu-item
                index="/device/listes"
                v-if="filterMenu('manager_list')"
                >设备列表</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3" v-if="filterMenu('maintenance')">
            <template slot="title">
              <i class="el-icon-help"></i>
              <span>运维管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/maintenance/rebacklist"
                v-if="filterMenu('maintenance_feeback')"
                >意见反馈</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4" v-if="filterMenu('article')">
            <template slot="title">
              <i class="el-icon-help"></i>
              <span>公众号文章</span>
            </template>
            <!-- <el-menu-item-group>
              <el-menu-item
                index="/maintenance/rebacklist"
                v-if="filterMenu('article_list')"
                >意见反馈</el-menu-item
              >
            </el-menu-item-group> -->
            <el-menu-item-group>
              <el-menu-item
                index="/maintenance/articleLlist"
                v-if="filterMenu('article_list')"
                >文章列表</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="5" v-if="filterMenu('system')">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span>系统管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/setting/menuManage"
                v-if="filterMenu('system_menu')"
                >菜单管理</el-menu-item
              >
              <el-menu-item
                index="/setting/userManage"
                v-if="filterMenu('system_user')"
                >人员管理</el-menu-item
              >
              <el-menu-item
                index="/setting/roleManage"
                v-if="filterMenu('system_role')"
                >角色管理</el-menu-item
              >
              <el-menu-item
                index="/setting/dictManage"
                v-if="filterMenu('system_dict')"
                >字典管理</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="6" v-if="filterMenu('route')">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span>路由管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/route/info" v-if="filterMenu('route_info')"
                >概览</el-menu-item
              >
              <el-menu-item
                index="/route/listes"
                v-if="filterMenu('route_listes')"
                >设备管理</el-menu-item
              >
              <el-menu-item
                index="/route/deploy"
                v-if="filterMenu('route_deploy')"
                >设备配置</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      menus: "menus",
    }),
    activeIndex() {
      console.log(this.$route.path);
      return this.$route.path;
    },
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      userName: window.sessionStorage.systName,
      show: true,
    };
  },
  created() {},
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    filterMenu(code) {
      const did = this.menus.filter((menu) => {
        if (menu.code.indexOf(code) != -1) {
          return true;
        }
        return false;
      });
      return did.length > 0;
      return true;
    },
    showNav() {
      this.isCollapse = !this.isCollapse;
      this.show = !this.show;
    },
  },
};
</script>
<style>
.el-menu {
  border-right: none;
}
.content-left {
  height: 100%;
}
.scroll-menu {
  height: 100%;
  /* overflow-y:scroll; */
}
.show-nav {
  position: absolute;
  /* right:-42px; */
  top: 50%;
  margin-top: -31px;
  width: 42px;
  height: 62px;
  background: url(../assets/images/show-nav.png) 0 0 no-repeat;
}
.hide-nav {
  position: absolute;
  right: -38px;
  top: 50%;
  margin-top: -31px;
  width: 42px;
  height: 62px;
  background: url(../assets/images/hide-nav.png) 0 0 no-repeat;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 0s;
}
</style>



// WEBPACK FOOTER //
// src/components/menuSide.vue